import { Dialog } from 'primereact/dialog';
import { FC, useEffect, useMemo, useState } from 'react';
import { ResursTreeApi } from '../../../services/modules/tree';
import { Field } from '../../resurs-props/field/field';
import { useForm } from 'react-hook-form';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { getDefaultValues } from '../../../utils/properties';
import styles from './selection-filter-modal.module.css';
import { Accordion, AccordionTab } from 'primereact/accordion';

export const SelectionFilterModal: FC<{
  selectionFilterData: ResursTreeApi.TSelectionFilterList;
  show: boolean;
  setShow: (value: boolean) => void;
  tree: ResursTreeApi.treeName;
  treeNeighboor?: ResursTreeApi.treeName;
}> = ({ selectionFilterData, show, setShow, tree, treeNeighboor }) => {
  const [initialValues, setInitialValues] = useState<any>();
  const {
    register,
    reset,
    control,
    handleSubmit,
    setValue,
    formState: { dirtyFields },
  } = useForm({
    defaultValues: initialValues,
  });

  const groupData = selectionFilterData.groups;

  useEffect(() => {
    const properties = groupData.reduce((acc, group) => {
      return acc.concat(group.properties as unknown as ConcatArray<never>);
    }, []);

    setInitialValues(getDefaultValues(properties));
  }, [groupData]);

  useEffect(() => {
    if (initialValues) {
      Object.keys(initialValues).forEach((key) => {
        setValue(key, initialValues[key]);
      });
    }
  }, [initialValues, setValue]);

  const groups = useMemo(
    () =>
      groupData.map((selectionFilter, idx) => ({
        name: selectionFilter.groupCaption,
        code: idx,
      })),
    [groupData]
  );
  const [group, setGroup] = useState(null);
  const [property, setProperty] = useState<string>('');
  const [strictCompare, setStrictCompare] = useState<boolean>(true);

  const change = () => {
    //console.info('change');
  };

  const converToGroupAndPropertyName = (
    form: { [key: string]: any },
    filter: ResursTreeApi.TSelectionFilterList
  ) => {
    const dirtyProperties = Object.keys(dirtyFields);
    const data = {} as { [key: string]: any };

    for (const [key, value] of Object.entries(form)) {
      if (!dirtyProperties.includes(key)) {
        continue;
      }

      const request = filter.groups.reduce((acc, group) => {
        const properties = group.properties.filter(
          (property) => property.key === key
        );
        if (properties.length > 0) {
          const property = properties[0];
          const groupCaption = group.groupCaption;
          const propertyLabel = property.templateOptions.label;

          acc.group = groupCaption;
          acc.property = propertyLabel;
          acc.value = value;
        }

        return acc;
      }, {} as { [key: string]: any });

      if (typeof data[request.group] === 'undefined') {
        data[request.group] = {};
      }

      data[request.group][request.property] = value;
    }

    return data;
  };

  const onSubmit = async (data: { [key: string]: any }) => {
    const response = await ResursTreeApi.setSelectionFilterByProperties({
      filter: converToGroupAndPropertyName(data, selectionFilterData),
      strict: strictCompare,
      tree: tree,
      treeNeighboor: treeNeighboor,
    });

    if (response) {
      setShow(false);
    } else {
      // ... something went wrong
    }
  };

  return (
    <Dialog
      dismissableMask
      header="Выделение объектов по свойствам"
      style={{ width: '30vw' }}
      visible={show}
      onHide={() => setShow(false)}
    >
      <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
        <div className={styles.description}>
          Укажите значения свойств, на основе которых будет выполнено выделение
          объектов:
        </div>

        <Accordion activeIndex={[0]}>
          {groupData.map((selectionFilter, groupIdx) => {
            return (
              selectionFilter.properties.length > 0 && (
                <AccordionTab
                  key={groupIdx}
                  header={selectionFilter.groupCaption}
                >
                  {selectionFilter.properties.map((prop, propIdx) => (
                    <Field
                      key={propIdx}
                      prop={prop}
                      uid={propIdx}
                      reg={register}
                      control={control}
                      change={change}
                      set={setValue}
                    />
                  ))}
                </AccordionTab>
              )
            );
          })}
        </Accordion>

        <div className={styles.checkbox}>
          <Checkbox
            inputId="strict"
            name="strict"
            onChange={(e) =>
              typeof e.checked !== 'undefined' && setStrictCompare(e.checked)
            }
            checked={strictCompare}
          />
          <label>Строгое соответствие по всем значениям</label>
        </div>

        <div className="flex flex-row gap-2 justify-content-end">
          <Button
            label="Сбросить"
            severity="secondary"
            onClick={() => reset()}
            type="reset"
          />
          <Button label="Выделить" />
        </div>
      </form>
    </Dialog>
  );
};
